@if (!(loading$ | async)) {
  <b>{{'etilize.error' | cxTranslate}}</b>
} @else {
  <cx-spinner></cx-spinner>
}

